var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "otherTypes" },
    [
      _vm.isTabsInitialized
        ? _c(
            "v-slide-group",
            { staticClass: "otherTypes__list", attrs: { "show-arrows": "" } },
            _vm._l(_vm.packageType, function (packageType) {
              return _c("v-slide-item", [
                _c("div", { staticClass: "otherTypes__item" }, [
                  _c("img", {
                    staticClass: "otherTypes__img",
                    attrs: { src: packageType.img, alt: packageType.name },
                  }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "otherTypes__title" }, [
                    _vm._v(_vm._s(packageType.name)),
                  ]),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "otherTypes__link",
                    attrs: { href: packageType.url },
                  }),
                ]),
              ])
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }